// extracted by mini-css-extract-plugin
export default {"afterPayModeSection":"p7-z","refreshPageWarning":"q7-z","redirectMessageText":"r7-z"};